exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".segment-row{border-radius:5px;padding:0 1em;margin:.5em;background-color:#fff;color:#777;font-weight:300;display:block;width:100%;height:50px;line-height:50px;cursor:pointer;border:1px solid #fff}.segment-row:first-child{margin-top:12em}.segment-row.active,.segment-row:hover{border-color:#8bc34a;box-shadow:0 0 2px #8bc34a}.segment-row.disabled{color:#bbb;cursor:default;border-color:#fff;box-shadow:none}.segment-row i.fa-chevron-right{color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/stylus-loader!./components/Segments/segment-row.styl
// module id = 471
// module chunks = 0